import { DisplayElementZod, ElementType, Schema } from "@avenueops/frontend-shared";
import { useFormContext } from "react-hook-form";
import Skeleton from "react-loading-skeleton";
import { trpc } from "utils/trpc";

interface Props {
  fields: {
    title: string;
    name: string;
  }[];
}

export function FormFieldsTable(): JSX.Element | null {
  const { watch } = useFormContext();

  const formTemplateId = watch("formTemplateId");

  const { data: formData, isLoading } = trpc.forms.getForm.useQuery({ formTemplateId: formTemplateId });
  const fields = formData?.templateJson as unknown as Schema;

  const filteredFields = fields?.elements
    ? Object.entries(fields.elements).reduce((acc, [, element]) => {
        if ("dataId" in element && element.dataId !== undefined) {
          if ("title" in element && element.title !== undefined) {
            acc.push(element);
          }
        }
        return acc;
      }, [] as any[])
    : [];

  return (
    <div className="border-x border-t border-gray-200 rounded-md overflow-hidden">
      <div className="h-11 items-center bg-gray-100  text-gray-900 flex flex-row px-6 font-medium text-xs">
        <div className="flex-1">FIELD TITLE</div>
        <div className="flex-1">FIELD NAME</div>
      </div>

      {formTemplateId ? (
        filteredFields.length == 0 ? (
          <div key={"0"} className="h-11 border-b border-gray-200 flex flex-row px-6 bg-white items-center">
            <div className="flex-1 text-sm text-gray-600">This form has no data fields.</div>
          </div>
        ) : (
          Object.values(filteredFields).map((element, index) => {
            return (
              <div key={element.id} className="h-11 border-b border-gray-200 flex flex-row px-6 bg-white items-center">
                <div className="flex-1 text-sm text-gray-600">{element.title}</div>
                <div className="flex-1 text-sm text-gray-600">{element.dataId}</div>
              </div>
            );
          })
        )
      ) : (
        <div key={"0"} className="h-11 border-b border-gray-200 flex flex-row px-6 bg-white items-center">
          <div className="flex-1 text-sm text-gray-600">Select a form to view its fields.</div>
        </div>
      )}
    </div>
  );
}
